import styles from './ScoopSkeleton.module.scss'

/**
 * ScoopSkeleton - A loading placeholder component
 *
 * @param {string} variant - Shape variant: 'text', 'rectangular', 'rounded', 'circular'
 * @param {string} animation - Animation type: 'wave', 'pulse', 'none'
 * @param {string|number} width - Width of the skeleton (e.g., '100%', 200, '80px')
 * @param {string|number} height - Height of the skeleton (e.g., 40, '50px')
 * @param {string} className - Additional CSS classes
 */
export const ScoopSkeleton = ({
    variant = 'rectangular',
    animation = 'wave',
    width,
    height,
    className = '',
    style = {},
    ...props
}) => {
    const classNames = [
        styles.skeleton,
        styles[variant],
        styles[`animation-${animation}`],
        className,
    ]
        .filter(Boolean)
        .join(' ')

    const inlineStyles = {
        ...style,
        ...(width !== undefined && { width: typeof width === 'number' ? `${width}px` : width }),
        ...(height !== undefined && {
            height: typeof height === 'number' ? `${height}px` : height,
        }),
    }

    return <div className={classNames} style={inlineStyles} {...props} />
}
